import { Routes } from '@angular/router';
import { MagazinePageComponent } from './magazine-page.component';
import { MagazineViewerPageComponent } from './magazine-viewer-page.component';
import { authGuard } from '../../core/services/auth.guard';

export const MAGAZINE_ROUTES: Routes = [
  { path: '', component: MagazinePageComponent },
  { path: ':id', component: MagazineViewerPageComponent, canActivate: [authGuard] }
];
